// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Face Filter — People Frame */

.filter-images-scope {
  --ff-bg: #f4f6fb;
  --ff-surface: #ffffff;
  --ff-on-surface: #12141a;
  --ff-muted: #5c6370;
  --ff-primary: #630ed4;
  --ff-primary-soft: rgba(99, 14, 212, 0.12);
  --ff-ring: rgba(99, 14, 212, 0.45);
  --ff-glow: rgba(99, 14, 212, 0.22);
  --ff-border: rgba(18, 20, 26, 0.08);
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background: var(--ff-bg);
  color: var(--ff-on-surface);
  min-height: 100%;
}

html.dark .filter-images-scope {
  --ff-bg: #0b0f17;
  --ff-surface: #151b28;
  --ff-on-surface: #f3f5f9;
  --ff-muted: #94a3b8;
  --ff-primary: #a78bfa;
  --ff-primary-soft: rgba(167, 139, 250, 0.16);
  --ff-ring: rgba(167, 139, 250, 0.55);
  --ff-glow: rgba(139, 92, 246, 0.28);
  --ff-border: rgba(255, 255, 255, 0.1);
}

.filter-images-scope .ff-hero {
  position: relative;
  overflow: hidden;
  border-radius: 1.75rem;
  padding: 2rem 2rem 2.25rem;
  margin-bottom: 1.75rem;
  background:
    radial-gradient(120% 80% at 100% 0%, var(--ff-primary-soft), transparent 55%),
    linear-gradient(145deg, var(--ff-surface) 0%, color-mix(in oklab, var(--ff-surface), var(--ff-primary) 4%) 100%);
  border: 1px solid var(--ff-border);
  box-shadow: 0 24px 60px -32px var(--ff-glow);
}

.filter-images-scope .ff-hero-glow {
  position: absolute;
  right: -4rem;
  top: -5rem;
  width: 18rem;
  height: 18rem;
  border-radius: 9999px;
  background: var(--ff-primary);
  opacity: 0.08;
  filter: blur(60px);
  pointer-events: none;
}

.filter-images-scope .ff-person-strip {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 1rem 1.25rem;
  border-radius: 1.25rem;
  background: color-mix(in oklab, var(--ff-surface), transparent 8%);
  border: 1px solid var(--ff-border);
  backdrop-filter: blur(10px);
}

.filter-images-scope .ff-avatar-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  min-width: 5.5rem;
  padding: 0.35rem 0.5rem 0.65rem;
  border-radius: 1rem;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;
}

.filter-images-scope .ff-avatar-btn:hover {
  transform: translateY(-2px);
  background: var(--ff-primary-soft);
}

.filter-images-scope .ff-avatar-btn--active .ff-avatar-ring {
  box-shadow: 0 0 0 3px var(--ff-ring), 0 12px 28px -8px var(--ff-glow);
}

.filter-images-scope .ff-avatar-ring {
  position: relative;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 9999px;
  padding: 3px;
  background: linear-gradient(135deg, var(--ff-primary), #8b5cf6 55%, #c084fc);
  transition: box-shadow 0.25s ease;
}

.filter-images-scope .ff-avatar-ring img,
.filter-images-scope .ff-avatar-ring .ff-avatar-fallback {
  width: 100%;
  height: 100%;
  border-radius: 9999px;
  object-fit: cover;
  border: 2px solid var(--ff-surface);
}

.filter-images-scope .ff-avatar-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #ede9fe, #ddd6fe);
  color: #5b21b6;
  font-weight: 700;
  font-size: 1.1rem;
}

html.dark .filter-images-scope .ff-avatar-fallback {
  background: linear-gradient(145deg, #312e81, #4c1d95);
  color: #e9d5ff;
}

.filter-images-scope .ff-avatar-name {
  max-width: 5.75rem;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--ff-on-surface);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-images-scope .ff-avatar-count {
  font-size: 0.62rem;
  font-weight: 500;
  color: var(--ff-muted);
}

.filter-images-scope .ff-view-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-width: 4.75rem;
  height: 5.75rem;
  padding: 0.5rem;
  border-radius: 1rem;
  border: 1.5px dashed color-mix(in oklab, var(--ff-primary), transparent 35%);
  background: var(--ff-primary-soft);
  color: var(--ff-primary);
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;
}

.filter-images-scope .ff-view-more:hover {
  transform: translateY(-2px);
  background: color-mix(in oklab, var(--ff-primary-soft), var(--ff-primary) 12%);
}

.filter-images-scope .ff-view-more-stack {
  display: flex;
  align-items: center;
  padding-left: 0.35rem;
}

.filter-images-scope .ff-view-more-stack span {
  width: 1.65rem;
  height: 1.65rem;
  margin-left: -0.55rem;
  border-radius: 9999px;
  border: 2px solid var(--ff-surface);
  background: linear-gradient(145deg, #c4b5fd, #8b5cf6);
  box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.25);
}

.filter-images-scope .ff-badge-new {
  position: absolute;
  top: -2px;
  right: -2px;
  padding: 0.1rem 0.35rem;
  border-radius: 9999px;
  background: #10b981;
  color: white;
  font-size: 0.55rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: 0 4px 10px -4px rgba(16, 185, 129, 0.6);
}

.filter-images-scope .ff-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 1rem;
  background: rgba(8, 10, 18, 0.55);
  backdrop-filter: blur(8px);
}

@media (min-width: 640px) {
  .filter-images-scope .ff-modal-backdrop {
    align-items: center;
  }
}

.filter-images-scope .ff-modal-panel {
  width: 100%;
  max-width: 32rem;
  max-height: min(82vh, 640px);
  overflow: hidden;
  border-radius: 1.5rem;
  background: var(--ff-surface);
  border: 1px solid var(--ff-border);
  box-shadow: 0 32px 80px -24px rgba(0, 0, 0, 0.45);
  animation: ff-slide-up 0.28s ease-out;
}

@keyframes ff-slide-up {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.filter-images-scope .ff-person-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(5.5rem, 1fr));
  /* gap: 0.75rem; */
  padding: 1rem 1.25rem 4rem 1.25rem;
  overflow-y: auto;
  max-height: calc(min(82vh, 640px) - 4.5rem);
}

.filter-images-scope .ff-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 4rem 1.5rem;
  border-radius: 1.25rem;
  border: 1px dashed var(--ff-border);
  background: color-mix(in oklab, var(--ff-surface), transparent 20%);
  color: var(--ff-muted);
  text-align: center;
}

.filter-images-scope .ff-confidence {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.65rem;
  border-radius: 9999px;
  background: var(--ff-primary-soft);
  color: var(--ff-primary);
  font-size: 0.7rem;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/pages/filter-images/filterImagesTheme.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,kCAAkC;EAClC,kCAAkC;EAClC,mCAAmC;EACnC,0DAA0D;EAC1D,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,oCAAoC;EACpC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB;;oHAEkH;EAClH,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,kEAAkE;EAClE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,4EAA4E;EAC5E,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,4EAA4E;EAC5E,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,mCAAmC;EACnC,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;EACnC,mEAAmE;EACnE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,kCAAkC;EAClC,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* Face Filter — People Frame */\n\n.filter-images-scope {\n  --ff-bg: #f4f6fb;\n  --ff-surface: #ffffff;\n  --ff-on-surface: #12141a;\n  --ff-muted: #5c6370;\n  --ff-primary: #630ed4;\n  --ff-primary-soft: rgba(99, 14, 212, 0.12);\n  --ff-ring: rgba(99, 14, 212, 0.45);\n  --ff-glow: rgba(99, 14, 212, 0.22);\n  --ff-border: rgba(18, 20, 26, 0.08);\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n  background: var(--ff-bg);\n  color: var(--ff-on-surface);\n  min-height: 100%;\n}\n\nhtml.dark .filter-images-scope {\n  --ff-bg: #0b0f17;\n  --ff-surface: #151b28;\n  --ff-on-surface: #f3f5f9;\n  --ff-muted: #94a3b8;\n  --ff-primary: #a78bfa;\n  --ff-primary-soft: rgba(167, 139, 250, 0.16);\n  --ff-ring: rgba(167, 139, 250, 0.55);\n  --ff-glow: rgba(139, 92, 246, 0.28);\n  --ff-border: rgba(255, 255, 255, 0.1);\n}\n\n.filter-images-scope .ff-hero {\n  position: relative;\n  overflow: hidden;\n  border-radius: 1.75rem;\n  padding: 2rem 2rem 2.25rem;\n  margin-bottom: 1.75rem;\n  background:\n    radial-gradient(120% 80% at 100% 0%, var(--ff-primary-soft), transparent 55%),\n    linear-gradient(145deg, var(--ff-surface) 0%, color-mix(in oklab, var(--ff-surface), var(--ff-primary) 4%) 100%);\n  border: 1px solid var(--ff-border);\n  box-shadow: 0 24px 60px -32px var(--ff-glow);\n}\n\n.filter-images-scope .ff-hero-glow {\n  position: absolute;\n  right: -4rem;\n  top: -5rem;\n  width: 18rem;\n  height: 18rem;\n  border-radius: 9999px;\n  background: var(--ff-primary);\n  opacity: 0.08;\n  filter: blur(60px);\n  pointer-events: none;\n}\n\n.filter-images-scope .ff-person-strip {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  padding: 1rem 1.25rem;\n  border-radius: 1.25rem;\n  background: color-mix(in oklab, var(--ff-surface), transparent 8%);\n  border: 1px solid var(--ff-border);\n  backdrop-filter: blur(10px);\n}\n\n.filter-images-scope .ff-avatar-btn {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 5.5rem;\n  padding: 0.35rem 0.5rem 0.65rem;\n  border-radius: 1rem;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: transform 0.2s ease, background 0.2s ease;\n}\n\n.filter-images-scope .ff-avatar-btn:hover {\n  transform: translateY(-2px);\n  background: var(--ff-primary-soft);\n}\n\n.filter-images-scope .ff-avatar-btn--active .ff-avatar-ring {\n  box-shadow: 0 0 0 3px var(--ff-ring), 0 12px 28px -8px var(--ff-glow);\n}\n\n.filter-images-scope .ff-avatar-ring {\n  position: relative;\n  width: 4.5rem;\n  height: 4.5rem;\n  border-radius: 9999px;\n  padding: 3px;\n  background: linear-gradient(135deg, var(--ff-primary), #8b5cf6 55%, #c084fc);\n  transition: box-shadow 0.25s ease;\n}\n\n.filter-images-scope .ff-avatar-ring img,\n.filter-images-scope .ff-avatar-ring .ff-avatar-fallback {\n  width: 100%;\n  height: 100%;\n  border-radius: 9999px;\n  object-fit: cover;\n  border: 2px solid var(--ff-surface);\n}\n\n.filter-images-scope .ff-avatar-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(145deg, #ede9fe, #ddd6fe);\n  color: #5b21b6;\n  font-weight: 700;\n  font-size: 1.1rem;\n}\n\nhtml.dark .filter-images-scope .ff-avatar-fallback {\n  background: linear-gradient(145deg, #312e81, #4c1d95);\n  color: #e9d5ff;\n}\n\n.filter-images-scope .ff-avatar-name {\n  max-width: 5.75rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--ff-on-surface);\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.filter-images-scope .ff-avatar-count {\n  font-size: 0.62rem;\n  font-weight: 500;\n  color: var(--ff-muted);\n}\n\n.filter-images-scope .ff-view-more {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-width: 4.75rem;\n  height: 5.75rem;\n  padding: 0.5rem;\n  border-radius: 1rem;\n  border: 1.5px dashed color-mix(in oklab, var(--ff-primary), transparent 35%);\n  background: var(--ff-primary-soft);\n  color: var(--ff-primary);\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.2s ease, background 0.2s ease;\n}\n\n.filter-images-scope .ff-view-more:hover {\n  transform: translateY(-2px);\n  background: color-mix(in oklab, var(--ff-primary-soft), var(--ff-primary) 12%);\n}\n\n.filter-images-scope .ff-view-more-stack {\n  display: flex;\n  align-items: center;\n  padding-left: 0.35rem;\n}\n\n.filter-images-scope .ff-view-more-stack span {\n  width: 1.65rem;\n  height: 1.65rem;\n  margin-left: -0.55rem;\n  border-radius: 9999px;\n  border: 2px solid var(--ff-surface);\n  background: linear-gradient(145deg, #c4b5fd, #8b5cf6);\n  box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.25);\n}\n\n.filter-images-scope .ff-badge-new {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  padding: 0.1rem 0.35rem;\n  border-radius: 9999px;\n  background: #10b981;\n  color: white;\n  font-size: 0.55rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  box-shadow: 0 4px 10px -4px rgba(16, 185, 129, 0.6);\n}\n\n.filter-images-scope .ff-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 60;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(8, 10, 18, 0.55);\n  backdrop-filter: blur(8px);\n}\n\n@media (min-width: 640px) {\n  .filter-images-scope .ff-modal-backdrop {\n    align-items: center;\n  }\n}\n\n.filter-images-scope .ff-modal-panel {\n  width: 100%;\n  max-width: 32rem;\n  max-height: min(82vh, 640px);\n  overflow: hidden;\n  border-radius: 1.5rem;\n  background: var(--ff-surface);\n  border: 1px solid var(--ff-border);\n  box-shadow: 0 32px 80px -24px rgba(0, 0, 0, 0.45);\n  animation: ff-slide-up 0.28s ease-out;\n}\n\n@keyframes ff-slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.filter-images-scope .ff-person-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(5.5rem, 1fr));\n  /* gap: 0.75rem; */\n  padding: 1rem 1.25rem 4rem 1.25rem;\n  overflow-y: auto;\n  max-height: calc(min(82vh, 640px) - 4.5rem);\n}\n\n.filter-images-scope .ff-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 4rem 1.5rem;\n  border-radius: 1.25rem;\n  border: 1px dashed var(--ff-border);\n  background: color-mix(in oklab, var(--ff-surface), transparent 20%);\n  color: var(--ff-muted);\n  text-align: center;\n}\n\n.filter-images-scope .ff-confidence {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.25rem 0.65rem;\n  border-radius: 9999px;\n  background: var(--ff-primary-soft);\n  color: var(--ff-primary);\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
